import { TextInput, Select, NumberInput, Textarea } from "@mantine/core";
import { IconTrash, IconPencil } from "@tabler/icons";
import _ from "lodash";
import {
  PageList,
  ENUM_FORM_DISPLAY,
  ENUM_FORM_LAYOUT_CONTAINER,
} from "../../components/pageList";
import AutoCodeInput from "../../components/autoCodeInput";

import { DatePicker } from "@mantine/dates";

import { useCellRender } from "../../hooks/useCellRender";
import { useFormatter } from "../../hooks/useFomatter";
import React, { useState } from "react";
import { useAuthUser } from "react-auth-kit";
import moment from "moment";
import UniqueTextInput from "../../components/uniqueTextInput";
import ActionCellRender from "../../components/actionCellRender";
import CommissionScheduleFileImporter from "../../components/commissionScheduleFileImporter";
import CommissionScheduleProductList from "../../components/commissionScheduleProductList";
const apiEntity = "commissionSchedule";

const commissionScheduleEditFormSchema = {
  title: "Commission Schedule",
  titleField: "code",
  display: {
    mode: ENUM_FORM_DISPLAY.LINK,
    size: "xl",
  },
  apiEntity,
  initialValues: {
    effectiveDate: moment().format("YYYY-MM-DD"),
    remark: "",
  },
  layout: {
    containers: [
      {
        key: "section-basic",
        parent: null,
        type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
        props: {
          title: "Schedule Info",
          titleOrder: 5,
          withBorder: false,
          minHeight: "0px",
          mt: 20,
          mb: 20,
        },
      },
      {
        key: "section-files",
        parent: null,
        type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
        props: {
          title: "Files",
          titleOrder: 5,
          withBorder: false,
          minHeight: "0px",
          mt: 20,
          mb: 20,
        },
      },
      {
        key: "section-productList",
        parent: null,
        type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
        props: {
          title: "Product List",
        },
      },
    ],
    fields: [
      {
        name: "effectiveDate",
        component: DatePicker,
        parent: "section-basic",
        type: "datePicker",
        props: {
          label: "Effective Date",
          clearable: true,
          valueFormat: "YYYY-MM-DD",
          allowFreeInput: true,
        },
      },
      {
        name: "endDate",
        component: DatePicker,
        parent: "section-basic",
        type: "datePicker",
        props: {
          label: "End Date",
          clearable: true,
          valueFormat: "YYYY-MM-DD",
          allowFreeInput: true,
        },
      },
      {
        name: "remark",
        component: Textarea,
        parent: "section-basic",
        props: {
          label: "Remark",
        },
      },
      {
        name: "productList",
        component: CommissionScheduleFileImporter,
        parent: "section-files",
        props: {},
      },
      {
        name: "productList",
        component: CommissionScheduleProductList,
        parent: "section-productList",
        props: {},
      },
    ],
  },
};

export const getCommissionScheduleEditFormSchema = () =>
  commissionScheduleEditFormSchema;

function CommissionSchedule() {
  const [cellRender] = useCellRender();
  const [formatter] = useFormatter();
  const [filterQuery, setFilterQuery] = useState(null);

  const auth = useAuthUser();

  const tableSchema = {
    showActionColumn: true,
    columns: [
      {
        field: "code",
        headerName: "Code",
        sortable: true,
        width: 200,
      },
      {
        field: "effectiveDate",
        headerName: "Effective Date",
        sortable: true,
        width: 200,
        cellRender: (col, data) =>
          data.effectiveDate
            ? moment(data.effectiveDate).format("YYYY-MM-DD")
            : "--",
        type: "date",
      },
      {
        field: "endDate",
        headerName: "End Date",
        sortable: true,
        width: 200,
        cellRender: (col, data) =>
          data.endDate ? moment(data.endDate).format("YYYY-MM-DD") : "--",
        type: "date",
      },
      {
        field: "remark",
        headerName: "Remark",
        sortable: true,
        width: 200,
      },
      {
        field: "action",
        cellRender: ActionCellRender,
        isAction: true,
        actions: [
          {
            name: "edit",
            icon: IconPencil,
            props: {
              //   color:"red"
            },
          },
        ],
        actionMenu: [
          {
            name: "delete",
            label: "Delete data",
            icon: IconTrash,
            props: {
              color: "red",
            },
          },
        ],
      },
    ],
    select: ["code effectiveDate endDate remark"],
  };

  const addFormSchema = {
    title: "Add Commission Schedule",
    display: {
      mode: ENUM_FORM_DISPLAY.MODAL,
      size: "xl", //xs, sm, xl  ....100%
    },
    showSaveBar: true,
    apiEntity,
    initialValues: {
      effectiveDate: moment().format("YYYY-MM-DD"),
      remark: "",
    },
    layout: {
      containers: [],
      fields: [
        {
          name: "code",
          component: AutoCodeInput,
          parent: "t1",
          props: {
            label: "Code",
            required: true,
          },
        },
        {
          name: "effectiveDate",
          component: DatePicker,
          parent: "t1",
          type: "datePicker",

          props: {
            label: "Effective Date",
            clearable: true,
            valueFormat: "YYYY-MM-DD",
            allowFreeInput: true,
          },
        },
        {
          name: "endDate",
          component: DatePicker,
          parent: "t1",
          type: "datePicker",

          props: {
            label: "End Date",
            clearable: true,
            valueFormat: "YYYY-MM-DD",
            allowFreeInput: true,
          },
        },

        //remark
        {
          name: "remark",
          component: Textarea,
          parent: "t1",
          props: {
            label: "Remark",
          },
        },

        // //import file
        // {
        //   name: "importFile",
        //   component: CommissionScheduleFileImporter,
        //   parent: "t1-2",
        //   props: {},
        // },
      ],
    },
  };

  const editFormSchema = commissionScheduleEditFormSchema;

  const formSchema = {
    add: addFormSchema,
    edit: editFormSchema,
  };
  return (
    <>
      <PageList
        title={"Commission Schedule"}
        apiEntity={apiEntity}
        tableSchema={tableSchema}
        formSchema={formSchema}
        initSort={{ by: "effectiveDate", order: "desc" }}
      />
    </>
  );
}
export default CommissionSchedule;
